import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WinterLogo } from '@sorare/core/src/atoms/icons/WinterLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, BrandXS } from '@sorare/core/src/atoms/typography';

const TiltedContainer = styled.div`
  transform: skew(-20deg);
  background: var(--c-score-high);
  padding: var(--half-unit) var(--double-unit);

  & > * {
    transform: skew(20deg);
  }
`;

type Props = { title?: ReactNode };
export const SeriesOnboardingHeader = ({ title }: Props) => {
  return (
    <Vertical center gap={3}>
      <Vertical center gap={1.5}>
        <TiltedContainer>
          <BrandXS color="var(--c-black)">
            <FormattedMessage
              id="SeriesOnboardingHeader.newSet"
              defaultMessage="New Set"
            />
          </BrandXS>
        </TiltedContainer>
        <WinterLogo style={{ height: '48px' }} />
      </Vertical>
      {!!title && <BrandS>{title}</BrandS>}
    </Vertical>
  );
};
